// ANCHOR React
import { useState } from 'react';

// ANCHOR Models
import createModel, { createSelector, createSelectors } from 'react-scoped-model';

// ANCHOR Utils
import { tuple } from '@lyon/utils/tuple';

// ANCHOR GraphQL
import { Form_Question_Types_Enum as QuestionType } from '@lyon/graphql/types';

interface IProps {
  formId: string;
  length: number;
}

export const CreateFormQuestionForm = createModel(({ formId, length }: IProps) => {
  const [name, setName] = useState<string>();
  const [type, setType] = useState<QuestionType>();
  const [success, setSuccess] = useState(false);
  const position = length + 1;

  const isDisabled = !name || !type;

  return {
    state: {
      name,
      type,
      success,
      isDisabled,
      position,
      formId,
    },
    handler: {
      name: setName,
      type: setType,
      success: setSuccess,
    },
  };
}, {
  displayName: 'Models.CreateFormQuestionForm',
});

export const useCreateFormQuestionFormType = createSelectors(
  CreateFormQuestionForm,
  ({ state, handler }) => tuple(
    state.type,
    handler.type,
  ),
);

export const useCreateFormQuestionFormName = createSelectors(
  CreateFormQuestionForm,
  ({ state, handler }) => tuple(
    state.name,
    handler.name,
    handler.success,
  ),
);

export const useCreateFormQuestionFormSuccess = createSelector(
  CreateFormQuestionForm,
  ({ state }) => state.success,
);

export const useCreateFormQuestionFormSubmitPayload = createSelectors(
  CreateFormQuestionForm,
  ({ state, handler }) => tuple(
    state.name,
    state.type,
    state.position,
    state.isDisabled,
    state.formId,
    handler.success,
  ),
);
